<template>
  <div class="PlainSideBar" id="scroll">
    <ExpertProfile v-if="$router.currentRoute.name == 'expertStore'"></ExpertProfile>

    <UserProfile v-else></UserProfile>

   <!-- <div class="dashboard-section">
        <h4>Dashboard Details</h4>
        <hr />
        <div
          class="dashboard-item"
          :class="{ active: activeSection === 'premium' }"
          @click="$emit('section-change', 'premium')"
        >
          <i class="el-icon-crown"></i>
          <span>StockAnts Premium</span>
        </div>

        <div
          class="dashboard-item"
          :class="{ active: activeSection === 'chat' }"
          @click="$emit('section-change', 'chat')"
        >
          <i class="el-icon-chat-dot-square"></i>
          <span>My Chat</span>
        </div>

        <div
          class="dashboard-item"
          :class="{ active: activeSection === 'faq' }"
          @click="$emit('section-change', 'faq')"
        >
          <i class="el-icon-question"></i>
          <span>FAQs</span>
        </div>

  </div> -->
  </div>
</template>

<script>
import UserProfile from "@/components/UserProfile.vue";
import ExpertProfile from "@/components/ExpertProfile.vue";

export default {
  name: "PlainSideBar",

   props: {
    activeSection: {
      type: String,
      default: ''
    }
  },

  components:{
    UserProfile,
    ExpertProfile
  },
};
</script>

<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.PlainSideBar {
  width: 265px;
  -webkit-box-shadow: 10px 0 10px -5px #d3d3d3;
  box-shadow: 10px 0 10px -5px #d3d3d3;
  position: fixed;
  height: 100%;
  overflow: auto;
  background-color: $filter-section-background-color;
  z-index: 3;
}
.dashboard-section {
  padding: 20px;

  h4 {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  hr {
    border: none;
    border-top: 1px solid #dcdcdc;
    margin: 10px 0 15px;
  }

  .dashboard-item {
    display: flex;
    align-items: center;
    padding: 10px 12px;
    border-radius: 8px;
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.3s ease, color 0.3s ease;

    i {
      margin-right: 10px;
      font-size: 16px;
      color: #6b7280;
    }

    span {
      color: #878787; 
    }

    &.active {
      background-color: #2D2E8D;
      
      i, span {
        color: white;
        font-weight: 600;
      }
    }
  }
}
</style>
